import { PortableComponent, defineComponent } from '@decify/cell-shopify/client';
import { buttonClickEvent, buttonName } from '../Button';
import { overlayClickEvent, overlayName } from '../Overlay';
import { Video, videoTagName } from '../Video/Video';
import { videoButtonName } from '../VideoButton';
import './VideoModal.scss';
export const videoModalName = 'VideoModal';
export const videoModalTagName = 'cell-component-video-modal';
export const videoModalOpenEvent = 'open';
export const videoModalCloseEvent = 'close';
export class VideoModal extends PortableComponent {
    classNames = {
        base: 'VideoModal',
        visible: 'VideoModal--Visible',
    };
    constructor() {
        super(videoModalName);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }
    componentDidMount() {
        globalThis.subscribe(`${buttonName}[${this.id}].${buttonClickEvent}`, this.open);
        globalThis.subscribe(`${videoButtonName}[${this.id}].${buttonClickEvent}`, this.open);
        this.subscribe(`${buttonName}[close].${buttonClickEvent}`, this.close);
        this.subscribe(`${overlayName}.${overlayClickEvent}`, this.close);
    }
    open() {
        this.classList.add(this.classNames.visible);
        this.videoElement.play();
        this.subscribe('click', () => this.videoElement.showControls(), { once: true });
        this.publish(videoModalOpenEvent);
    }
    close() {
        this.classList.remove(this.classNames.visible);
        this.videoElement.pause();
        this.videoElement.reset();
        this.videoElement.hideControls();
        this.publish(videoModalCloseEvent);
    }
    get videoElement() {
        const videoElement = this.querySelector(videoTagName);
        if (!videoElement) {
            throw new Error('Video element not found');
        }
        if (!(videoElement instanceof Video)) {
            throw new Error('Video element is not an instance of Video');
        }
        return videoElement;
    }
}
defineComponent(videoModalTagName, VideoModal);
